export const trading = {
  等待确认: 'Aguardando confirmação',
  gas矿工费: 'Taxa de minerador de gás',
  审核扫描: 'Verificação de Auditoria',
  警报: 'Alerta',
  无警报: 'Sem alerta',
  显示更多: 'Mostrar mais',
  infos: "Esses resultados de auditoria são automáticos e realizados por entidades externas à Biking. Eles não são recomendações e devem ser considerados juntamente com outros fatores. A Biking não verifica nem se responsabiliza pela qualidade dos dados obtidos por esses auditores externos. Sempre conduza sua própria pesquisa e consulte várias fontes de informação.",
  请输数量: 'Digite a quantidade',
  兑换: 'Trocar',
  价格: 'Preço',
  选择代币: 'Escolher Token',
  搜索名称或粘贴地址: 'Pesquisar por nome ou colar endereço',
  DEXT分数: 'Pontuação DEXT',
  更多检测: 'Mais verificações',
  检查审核: 'Verificar auditoria',
  令牌描述: 'Descrição do token',
  更新: 'Atualizar',
  合同验证: 'Verificação de contrato',
  买入税: 'Imposto de compra',
  代理合同: 'Contrato de agente',
  可造币: 'Cunhável',
  可修改税收: 'Imposto modificável',
  转让可暂停: 'Transferência pausável',
  黑名单: 'Lista negra',
  找回所有权: 'Recuperar propriedade',
  可修改余额: 'Saldo modificável',
  隐藏的所有者: 'Proprietário oculto',
  自毁: 'Auto-destruir',
  外部呼叫风险: 'Risco de chamada externa',
  可以购买: 'Disponível para compra',
  最大卖出比率: 'Taxa máxima de venda',
  白名单: 'Lista branca',
  反鲸鱼可修改: 'Anti-whale modificável',
  交易冷却时间: 'Tempo de resfriamento da transação',
  可修改的个人税收: 'Imposto pessoal modificável',
  真的假的代币: 'Token real/falso',
  空投骗局: 'Fraude de airdrop',
  可以信任: 'Confiança',
  业主地址: 'Endereço do proprietário',
  所有者余额: 'Saldo do proprietário',
  业主百分比: 'Percentual do proprietário',
  创建者地址: 'Endereço do criador',
  创造者余额: 'Saldo do criador',
  创造者百分比: 'Percentual do criador',
  配对持有者: 'Proprietário do par',
  其他风险: 'Outros riscos',
  注意: 'Aviso',
  交易: 'Transações',
  dex委托: 'comissão swap',
  dex历史委托: 'comissão histórica swap',
  kpsj: 'Horário de Abertura',
  jlks: 'Tempo para Iniciar',
  t: 'Dias',
  s: 'Horas',
  f: 'Minutos',
  m: 'Segundos',

  zgj: 'preço mais alto：',
  zdj: 'menor preço：',
  gflj: 'Links Oficiais',
  gw: 'Site Oficial',
  qkllq: 'Explorador de Blocos',
  scfxsj: 'Data de Primeira Emissão',
  fxzl: 'Total de Emissão',
  ltzl: 'Total Circulante',
  jy: 'Negociar',
  sj: 'Preço de Mercado',
  tbxx: 'Informações do Gráfico',
  bzgk: 'Visão Geral da Moeda',
  jcb: 'Versão básica',
  ddb: 'Livro de Ordens',
  zxcj: 'Últimos Negócios',

  reload: "Recarregar",
  socketError: "Erro de Rede, por favor",
  noData: "Sem dados",
  entrustorder: "Livro de Ordens",
  prices: "Preço",
  quantity: "Quantidade",
  grandtotal: "Total",
  transamount: "Montante",
  time: "Tempo",
  available: "Disponível",
  limitorder: "Ordem Limitada",
  plancommission: "Ordem Planejada",
  currentcommission: "Ordens Atuais",
  historycommission: "Histórico de Ordens",
  completecommission: "Ordens Completas",
  funds: 'Fundos',
  hidetrading: "Esconder Outros Pares de Negociação",
  morecurrentcommission: "Mais Ordens Atuais",
  morehistorycommission: "Mais Histórico de Ordens",
  moredocommission: "Mais Ordens Completas",
  realtimetrans: "Negociações em Tempo Real",
  myassets: "Meus Ativos",
  detail: "Detalhes",
  buyin: "Comprar",
  sellout: "Vender",
  login: "Entrar",
  transfer: "Transferir",
  recharge: "Recarregar",
  withdrawal: "Retirar",
  quickpurchase: "Compra Rápida com Dinheiro Fiat",
  default: "Padrão",
  ordertime: "Hora da Ordem",
  windingtime: "Tempo de enrolamento",
  tradingpair: "Par de Negociação",
  direction: "Direção",
  types: "Tipo",
  commissionprice: "Preço da Ordem",
  commissionnumber: "Quantidade da Ordem",
  dealprice: "Preço Médio",
  dealnumber: "Quantidade Preenchida",
  triggerprice: "Preço de Gatilho",
  cancelall: "Cancelar Tudo",
  averageprice: "Preço Médio",
  totalsum: "Total",
  fixedprice: "Preço Limitado",
  marketprice: "Preço de Mercado",
  codeExpired: "Código QR Expirado",
  clickRefresh: "Clique para Recarregar",
  QRsuccessfully: "Código QR Escaneado com Sucesso",
  loginInApp: "Por favor, confirme o login dentro do APP",
  backtoQR: "Voltar para o Login com Código QR",
  loginSuccess: "Você entrou com sucesso. Bem-vindo ao Biking!",
  loadingText: "Carregando...",
  searchPlaceholder: "Pesquisar",
  all: "Todos",
  currency: "Moeda",
  price: "Último Preço",
  market: "Mercado",
  increase: "Variação",
  highestPrice: "Máximo",
  minimumPrice: "Mínimo",
  turnover: "Volume",
  jydlb: "Lista de Pares de Negociação",
  bzjs: "Introdução da Moeda",
  currencyTransaction: "Negociação de Spot",
  leveragedTransaction: "Negociação Alavancada",
  warning:
  "Aviso de Risco: O fork do Bitcoin Cash possui grande incerteza. Negociar ou investir em tokens futuros de fork envolve alto risco. Se uma cadeia não tiver suporte dos mineradores, ela pode não sobreviver, e os tokens relacionados podem não ter valor. A Biking não faz nenhum compromisso com o valor de quaisquer tokens futuros de fork!",
  zb: "Indicadores",
  date: "Hora",
  UpAnddown: "Variação",
  amplitude: "Amplitude",
  0: "Hora",
  1: "1 Min",
  5: "5 Mins",
  15: "15 Mins",
  30: "30 Mins",
  60: "1 Hora",
  240: "4 Horas",
  3600: "1 Dia",
  10800: "1 Semana",
  dates: "Período: ",
  password: "Senha de Transação",
  errorPassword: "Por favor, insira a senha de transação correta",
  worningPassword: "Por favor, insira sua senha de transação",
  cancel: "Cancelar",
  sure: "Confirmar",
  canBuy: "Comprar Disponível",
  canCell: "Vender Disponível",
  withdraw: "Retirar",
  otc: "OTC, Acesso e Retirada Rápida em Dinheiro Fiat",
  enterPrice: "Digite o Preço",
  sellingPrice: "Preço de Venda",
  purchasePrice: "Preço de Compra",
  salesVolume: "Volume de Vendas",
  buyingVolume: "Volume de Compras",
  volume: "Volume",
  serviceCharge: "Taxa",
  vip: "Upgrade para VIP para Taxas Menores",
  or: "ou",
  register: "Registrar",
  totalPrice: "O montante da transação não pode ser maior que",
  amountTip: "Por favor, insira a quantidade correta",
  amountTipError: "A quantidade não pode ser maior que",
  limitTrading: "Ordem Limitada",
  priceReminder: "Lembrete de Preço",
  SMSReminder: "Lembrete SMS",
  loginAccount: "Conta de Login",
  phone: "Telefone",
  phoneNum: "Digite o Número de Telefone",
  phoneTips: "Por favor, insira um número de telefone válido",
  email: "E-mail",
  emailNum: "Digite o E-mail",
  emailTips: "Por favor, insira um endereço de e-mail válido",
  aears: "Selecione o Código de Área",
  passwordError: "Por favor, insira a senha correta",
  passwordTips: "Por favor, insira sua senha",
  forgetPassword: "Esqueci a Senha",
  noAccount: "Sem Conta?",
  goRegister: "Registre-se Agora",
  appsys: "Login Seguro com o APP Escaneando o Código QR",
  xzapp: "Baixe o Último APP",
  mmdl: "Login com Senha",
  smdl: "Login com Código QR",
  google: "Verificador do Google",
  nybd: "Você já vinculou",
  zqyzm: "Por favor, insira o código de verificação correto",
  fsyzm: "Enviar Código de Verificação",
  flv: "Taxa",
  jz: "Valor Líquido",
  jzdesc1:
  "Valor Líquido de Compra = Valor Líquido no ponto de ajuste anterior * [1 + 3 * (Preço Mais Recente - Preço no ponto de ajuste anterior) / Preço no ponto de ajuste anterior * 100%];",
  jzdesc2:
  "Valor Líquido de Venda = Valor Líquido no ponto de ajuste anterior * [1 - 3 * (Preço Mais Recente - Preço no ponto de ajuste anterior) / Preço no ponto de ajuste anterior * 100%];",
  sbd: "3x Longo",
  sbs: "3x Curto",
  flvjs:
  'A taxa de financiamento de ETF é a taxa de gestão correspondente que a plataforma cobra diariamente pelo nível de alavancagem, para pagar a taxa de financiamento gerada pela carteira de fundos. A taxa de gestão será refletida nas mudanças de valor líquido, ou seja, será apresentada como "deduzindo o valor do ETF de alavancagem correspondente" e só será cobrada às 0 horas no horário de Singapura. Se o produto não for mantido durante esse horário, nenhuma taxa será cobrada.',
  mzsm: "Aviso Legal",
  ido: "Eu li e concordo com",
  exemption1: "Caro cliente, olá!",
  exemption2:
  "Obrigado por fazer login e usar os produtos ETF e serviços relacionados fornecidos pela plataforma Biking (Biking.ai) (doravante denominados “Produtos ETF”). Por favor, leia atentamente a descrição dos Produtos ETF e o aviso de risco abaixo. Se você continuar a usar os Produtos ETF após a leitura, será considerado que você compreendeu e aceitou completamente os riscos dos Produtos ETF, pode arcar com as perdas potenciais resultantes do uso dos Produtos ETF e concorda com o conteúdo completo deste aviso de exoneração. Clique para ler a descrição dos Produtos ETF:",
  exemption3: "FAQ do Produto ETF Alavancado",
  exemption4: "Aviso de Risco:",
  exemption5:
  "1. O preço de compra/venda que você define não deve diferir significativamente do valor líquido por cota; caso contrário, você pode sofrer perdas correspondentes.",
  exemption6: "2. Se a direção de sua negociação estiver errada, em condições extremas de mercado, pode haver o risco do preço se aproximar de zero.",
  exemption7:
  "A plataforma Biking lembra aqui com seriedade que você será responsável por quaisquer perdas ou responsabilidades decorrentes dos riscos acima mencionados, e a plataforma Biking não assumirá nenhuma responsabilidade por isso. Este aviso de exoneração, juntamente com outros acordos, declarações, regras e similares da plataforma Biking, constitui um acordo completo entre a plataforma Biking e você sobre os serviços e produtos da plataforma Biking.",
  bzjs1: "1. “3L” significa que o preço do par de negociação aumenta 1% e o valor líquido do produto aumenta 3%.",
  bzjs2: "2. “3S” significa que o preço do par de negociação cai 1% e o valor líquido do produto aumenta 3%.",
  bzjs3: "3. O valor líquido é ajustado normalmente diariamente à meia-noite, mas também pode ser ajustado intradiariamente em condições extremas de mercado.",
  bzjs4: "4. As taxas de gerenciamento correspondentes serão cobradas diariamente para cada alavancagem.",
  bzjs5:
  "5. Antes de negociar, verifique o valor líquido com cuidado. Em condições extremas de mercado, pode haver o risco de o preço se aproximar de zero ou divergir significativamente do valor líquido. Por favor, esteja ciente desse risco e controle seu risco de investimento.",
  gdjk: "Para mais detalhes, por favor, verifique os anúncios",
  firstTrading: "Antes da primeira negociação, defina a senha de transação primeiro",
  status: "Status",
  status1: "Aguardando Emparelhamento",
  status2: "Não Concluído",
  status3: "Usuário Cancelou",
  status4: "Parte Concluído",
  status5: "Completamente Concluído",
  status6: "Inválido",
  allCancel: "Cancelar Todas as Ordens em Lote",
  canceld: "Cancelar",
  cancelsuccess: "Todas as ordens canceladas com sucesso, foram canceladas [*] ordens",
  VIP1: "Seu Nível VIP",
  VIP2: "Taxas de negociação mais baixas e melhor experiência de negociação",
  VIP3: "Taker (tomador):",
  VIP4: "Maker (ofertante):",
  buyAmount: "A quantidade de compra não pode ser maior que",
  sellAmount: "A quantidade de venda não pode ser maior que",
  buyAmountMin: "Seu saldo disponível para compra é insuficiente",
  sellAmountMin: "Seu saldo disponível para venda é insuficiente",
}



// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/pt_BR.js